import React from 'react'
import Helmet from 'react-helmet'
import autoBind from 'react-autobind'

import ContactForm from '../components/ContactForm'
import Header from "../components/Nav.js";
import './Contact.css'
import './Heritage.css'

class ContactPage extends React.Component {
   constructor(props) {
    super(props);
    this.state = {
      display:true,
    };
    autoBind(this);
  }

  handleClick(){
    this.setState({display: !this.state.display});
  }

  render(){
  const { title } = this.props.page
  const displayState = this.state.display ? "contactDisplayFalse" : "contactDisplayTrue";
    const centerState = this.state.display ? "contactLeft" : "contactCenter";
  return (
      <div>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Header />
      <div className="heritageTitle">{title}</div>
      <div className="contactWrapper">
      <div className={"contactContacts "+ centerState}>
        <div className={"contactContactsInfo "+  displayState}>
          <div className="contactContactsInfo_1">
            <a href={"mailto:"+this.props.page.email} target="_top" className="contactContactsMail">{this.props.page.email}</a>
          </div>
          <div className="contactName">
            {this.props.page.name1}
          </div>
          <div className="contactAddress1">
            {this.props.page.address1}
          </div>
          <div className="contactAddress2">
            {this.props.page.address2}
          </div>
        </div>

        <div >
          <ContactForm onClick={this.handleClick} location="contact" />
        </div>
      </div>
     </div> 
    </div>
  )
}}


export default ContactPage;



// WEBPACK FOOTER //
// ./src/views/Contact.js